import React, { useState, useEffect } from "react";
import { CircleArrow as ScrollUpButton } from "react-scroll-up-button";
import $ from "jquery";
import "./App.scss";
import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./components/About";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Skills from "./components/Skills";

function App() {
  const [resumeData, setResumeData] = useState({});
  const [sharedData, setSharedData] = useState({});

  const applyPickedLanguage = (pickedLanguage, oppositeLangIconId) => {
    swapCurrentlyActiveLanguage(oppositeLangIconId);
    document.documentElement.lang = pickedLanguage;
    var resumePath =
      document.documentElement.lang === window.$primaryLanguage
        ? `res_secondaryLanguage.json`
        : `res_primaryLanguage.json`;
    loadResumeFromPath(resumePath);
    loadSharedData(resumePath);
  };

  const swapCurrentlyActiveLanguage = (oppositeLangIconId) => {
    var pickedLangIconId =
      oppositeLangIconId === window.$primaryLanguageIconId
        ? window.$secondaryLanguageIconId
        : window.$primaryLanguageIconId;
    oppositeLangIconId === window.$primaryLanguageIconId
      ? (document.title = "Aslan Khorramie")
      : (document.title = "اصلان خرمی");
    document
      .getElementById(oppositeLangIconId)
      .removeAttribute("filter", "brightness(40%)");
    document
      .getElementById(pickedLangIconId)
      .setAttribute("filter", "brightness(40%)");
  };

  useEffect(() => {
    const fetchLang = async () => {
      if (window.$primaryLanguage && window.$secondaryLanguageIconId) {
        applyPickedLanguage(
          window.$primaryLanguage,
          window.$secondaryLanguageIconId
        );
      }
      if (!window.$primaryLanguage && !window.$secondaryLanguageIconId) {
        return null;
      }
    };
    fetchLang();
    // eslint-disable-next-line
  }, []);

  const loadResumeFromPath = (path) => {
    $.ajax({
      url: path,
      dataType: "json",
      cache: false,
      success: function (data) {
        setResumeData(data);
      },
      error: function (xhr, status, err) {
        alert(err);
      },
    });
  };

  const loadSharedData = (path) => {
    $.ajax({
      url: path,
      dataType: "json",
      cache: false,
      success: function (data) {
        if (data.basic_info.description_header === "سلام") {
          $.ajax({
            url: `secondaryPortfolio_shared_data.json`,
            dataType: "json",
            cache: false,
            success: function (data) {
              setSharedData(data);
              // document.title = `${sharedData.basic_info.name}`;
            },
            error: function (xhr, status, err) {
              alert(err);
            },
          });
        } else {
          $.ajax({
            url: `portfolio_shared_data.json`,
            dataType: "json",
            cache: false,
            success: function (data) {
              setSharedData(data);
              // document.title = `${sharedData.basic_info.name}`;
            },
            error: function (xhr, status, err) {
              alert(err);
            },
          });
        }
      },
      error: function (xhr, status, err) {
        alert(err);
      },
    });
  };

  return (
    <div>
      <ScrollUpButton
        style={{
          zIndex: "100",
          border: "3px black solid",
          backgroundColor: "rgba(255, 255, 255, 0.3)",
        }}
      />
      <div className="header-holder">
        <Header sharedData={sharedData.basic_info} />
        <div className="col-md-12 mx-auto text-center language">
          <div
            onClick={() =>
              applyPickedLanguage(
                window.$primaryLanguage,
                window.$secondaryLanguageIconId
              )
            }
            style={{ display: "inline" }}
          >
            <span
              className="iconify language-icon mr-5"
              data-icon="twemoji-flag-for-flag-iran"
              data-inline="false"
              id={window.$primaryLanguageIconId}
            ></span>
          </div>
          <div
            onClick={() =>
              applyPickedLanguage(
                window.$secondaryLanguage,
                window.$primaryLanguageIconId
              )
            }
            style={{ display: "inline" }}
          >
            <span
              className="iconify language-icon"
              data-icon="twemoji-flag-for-flag-united-states"
              data-inline="false"
              id={window.$secondaryLanguageIconId}
            ></span>
          </div>
        </div>
      </div>
      <About
        resumeBasicInfo={resumeData.basic_info}
        sharedBasicInfo={sharedData.basic_info}
      />
      <Projects
        resumeProjects={resumeData.projects}
        resumeBasicInfo={resumeData.basic_info}
      />
      <Skills
        sharedSkills={sharedData.skills}
        resumeBasicInfo={resumeData.basic_info}
      />
      <Experience
        resumeExperience={resumeData.experience}
        resumeBasicInfo={resumeData.basic_info}
      />
      <Footer sharedBasicInfo={sharedData.basic_info} />
    </div>
  );
}

export default App;
